export const INTEGRATION_DRAWERS = {
  SALESFORCE_INTEGRATION: 'salesforceIntegration',
};
